import { Link } from 'react-router';
import { twMerge } from 'tailwind-merge';

import { LogoIcon } from '@src/assets/icons';
import { NAVIGATION } from '@src/constants';

import { IHeader } from './interfaces';

export const HeaderLogo = ({
  clickableLogo,
  logoProps,
  extraContent,
}: {
  clickableLogo: boolean;
  logoProps?: IHeader['logoProps'];
  extraContent?: React.ReactNode;
}) => {
  const logoWrapperClassName = twMerge(
    extraContent && 'flex h-16 items-center',
  );
  const logoClassName = twMerge('w-auto h-4 md:h-7 mb-1', logoProps?.className);

  if (clickableLogo) {
    return (
      <Link to={NAVIGATION.HOME} className={logoWrapperClassName}>
        <LogoIcon {...logoProps} className={logoClassName} />
      </Link>
    );
  }

  return (
    <div className={logoWrapperClassName}>
      <LogoIcon {...logoProps} className={logoClassName} />
    </div>
  );
};
